<template>
  <footer class="columns footer-wrapper">
    <div class="column">
      <div class="content container">
        <p class="is-size-7 is-pulled-left">
          Copyright © {{ (new Date()).getFullYear() }} Truckl LLC - All Rights Reserved.
        </p>
        <!--
        <p class="is-size-7 is-pulled-right">
          last updated: {{ formattedBuildDate}}
        </p>
        -->
      </div>
    </div>
  </footer>
</template>

<script>
import { format } from 'date-fns'
export default {
  name: 'Footer',

  data() {
    return {
      buildDate: process.env.VUE_APP_BUILD_DATE_EPOCH
    }
  },

  computed: {
    formattedBuildDate() {
      return format(this.buildDate, 'YYYY-MM-DD h:m A Z')
    }
  }
}
</script>

<style scoped>
.footer-wrapper {
  padding: 1.5rem;
  width: 100%;
  background-color: transparent;
}
</style>
